import { ColumnDef } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { GetPricingsheetApiV1PricingsheetGetResponse } from "@/client";
import { Button } from "@/components/ui/button";

export const columns: ColumnDef<GetPricingsheetApiV1PricingsheetGetResponse["data"][number]>[] = [
  {
    accessorKey: "period",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-auto w-full p-1 text-[10px] font-semibold sm:p-2 sm:text-sm"
        >
          Period
          <ArrowUpDown className="ml-0.5 h-3 w-3 sm:ml-2 sm:h-4 sm:w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      return <div className="text-[10px] font-medium sm:text-xs">{row.getValue("period")}</div>;
    },
  },
  {
    accessorKey: "bid_price",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-auto w-full p-1 text-[10px] font-semibold sm:p-2 sm:text-sm"
        >
          Bid
          <ArrowUpDown className="ml-0.5 h-3 w-3 sm:ml-2 sm:h-4 sm:w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue("bid_price"));
      const formatted = amount
        ? new Intl.NumberFormat("eu-EU", {
            style: "currency",
            currency: "EUR",
          }).format(amount)
        : null;

      return <div className="whitespace-nowrap text-[10px] sm:text-xs">{formatted}</div>;
    },
  },
  {
    accessorKey: "offer_price",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-auto w-full p-1 text-[10px] font-semibold sm:p-2 sm:text-sm"
        >
          Offer
          <ArrowUpDown className="ml-0.5 h-3 w-3 sm:ml-2 sm:h-4 sm:w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue("offer_price"));
      const formatted = amount
        ? new Intl.NumberFormat("eu-EU", {
            style: "currency",
            currency: "EUR",
          }).format(amount)
        : null;

      return <div className="whitespace-nowrap text-[10px] sm:text-xs">{formatted}</div>;
    },
  },
  {
    accessorKey: "settlement_price",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-auto w-full p-1 text-[10px] font-semibold sm:p-2 sm:text-sm"
        >
          Settle
          <ArrowUpDown className="ml-0.5 h-3 w-3 sm:ml-2 sm:h-4 sm:w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue("settlement_price"));
      const formatted = amount
        ? new Intl.NumberFormat("eu-EU", {
            style: "currency",
            currency: "EUR",
          }).format(amount)
        : null;

      return <div className="whitespace-nowrap text-[10px] sm:text-xs">{formatted}</div>;
    },
  },
  {
    accessorKey: "delta_price",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-auto w-full p-1 text-[10px] font-semibold sm:p-2 sm:text-sm"
        >
          Delta
          <ArrowUpDown className="ml-0.5 h-3 w-3 sm:ml-2 sm:h-4 sm:w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("delta_price"));
      const formattedValue = value ? value.toFixed(2) : null;

      if (value < 0) {
        return (
          <div className="flex items-center justify-center text-[10px] text-red-500 sm:text-xs">
            <ArrowDown className="mr-0.5 h-3 w-3 sm:mr-1 sm:h-4 sm:w-4" />
            {formattedValue}
          </div>
        );
      } else if (value > 0) {
        return (
          <div className="flex items-center justify-center text-[10px] text-green-500 sm:text-xs">
            <ArrowUp className="mr-0.5 h-3 w-3 sm:mr-1 sm:h-4 sm:w-4" />
            {formattedValue}
          </div>
        );
      } else {
        return <div className="flex items-center justify-center text-[10px] sm:text-xs">{formattedValue}</div>;
      }
    },
  },
];
